/* Swiss Notes — homepage conversion cleanup: shorter browse path, products before offers. */
(()=>{
  if(window.SwissNotesHomeConversion)return;
  window.SwissNotesHomeConversion=true;
  const find=id=>document.querySelector('[id$="__'+id+'"]');
  const optimize=()=>{
    if(!document.body||document.body.classList.contains('template-product'))return;
    const best=find('featured-collections-1');
    const all=find('featured-collections-2');
    const bundle=find('sn-animated-bundle');
    const offers=find('sn-bundle-banner-2');
    const mood=find('sn-bundle-banner');
    if(best&&bundle&&best.parentNode===bundle.parentNode)best.after(bundle);
    if(bundle&&all&&bundle.parentNode===all.parentNode)bundle.after(all);
    if(all&&offers&&all.parentNode===offers.parentNode)all.after(offers);
    if(mood&&best&&mood.parentNode===best.parentNode&&mood.nextElementSibling!==best)mood.after(best);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',optimize,{once:true});else optimize();
  document.addEventListener('shopify:section:load',optimize);
})();
